import React from 'react'

const MarketplaceEnabledContext = React.createContext<boolean>(false)

export function MarketplaceEnabledProvider({
  children,
  isMarketplaceEnabled = false,
}: React.PropsWithChildren<{isMarketplaceEnabled?: boolean}>) {
  return <MarketplaceEnabledContext value={isMarketplaceEnabled}>{children}</MarketplaceEnabledContext>
}

export function useMarketplaceEnabled() {
  return React.use(MarketplaceEnabledContext)
}
